import FieldLabel from './FieldLabel';

export default FieldLabel;
